"use client"
import React, { useState, useEffect } from 'react';
import { generateUriSegment } from 'common/utils/mediaRouteHelper';

const VIDEO_RESOURCES_TYPES = 'video';
const RECORDED_RESOURCES_TYPES = 'recorded';
const PHOTOSETS_RESOURCES_TYPES = 'photoset_sections';
const STORE_RESOURCES_TYPES = 'store_sections';


const STORIES_SORTING = [
   { name: 'Newest', value: 'date_added:desc' },
   { name: 'Oldest', value: 'date_added:asc' },
   { name: 'Most liked', value: 'likes_count:desc' },
   { name: 'Most viewed', value: 'views_count:desc' },
];
const STORE_SORTING = [
   { name: 'Newest ', value: 'date_added:desc' },
   { name: 'Oldest', value: 'date_added:asc' },
   { name: 'Name • A - Z', value: 'name:asc' },
   { name: 'Name • Z - A', value: 'name:desc' },
   { name: 'Price • Low to high', value: 'price:asc' },
   { name: 'Price • High to low', value: 'price:desc' },
];
const MEDIA_SORTING = [
   { name: 'Newest', value: 'date_added:desc' },
   { name: 'Oldest ', value: 'date_added:asc' },
   { name: 'Name • A - Z', value: 'name:asc' },
   { name: 'Name • Z - A', value: 'name:desc' },
   { name: 'Most liked', value: 'likes_count:desc' },
   { name: 'Most viewed', value: 'views_count:desc' },
   { name: `Comments • Highest to lowest`, value: 'comments_count:desc' },
   { name: `Comments • Lowest to highest`, value: 'comments_count:asc' },
]
const STORE_TYPES = [
   { name: 'Bundle', id: 'content_bundle_item' },
   { name: 'Digital item', id: 'digital_item' },
   { name: 'Downloadable digital item', id: 'attachment_item' },
   { name: 'Digital item pricing by the minute', id: 'priced_by_the_minute' },
   { name: 'Physical item', id: 'physical_item' },
];
const STATUS_FILTERS = [
   { name: 'New', value: 'new' },
   { name: 'Watched', value: 'watched' },
   // { name: 'Unwatched', value: 'unwatched' },
   { name: 'Liked', value: 'liked' },
   { name: 'Favorites', value: 'favorite' },
]

const tryRequire = (path) => {
   try {
      return require(`${ path }`);
   } catch (err) {
      console.log(err)
      return null;
   }
};

const importComponent = (path) => {
   return React.lazy(async () => await import(`${ path }`));
};

const generateApiParams = (collections, contentDefaultSorting, contentType, page = 1) => {
   const type = collections.type
   let types = {
      model: 'casts',
      tag: 'tags',
      collection: 'collections',
   }
   let query = [`page=${ page }`, `sortBy=${ contentDefaultSorting }`]
   if('recorded_stream' === contentType){
      query = [
         ...query,
         'video_type=livestream',
      ]
   }
   if('all' !== type){
      let value = 0;
      if(collections.ids  && collections?.ids?.length){
         value = collections.ids
      }
      if('select' === type){

         query.push(`ids=${ encodeURIComponent(value) }`)
      } else {

         query.push(`query[]=${ types[collections.type] }=${ encodeURIComponent(value) }`)
      }
   }
   return query
}

function useDynamicComponentImport(name, pathPrefix, isPreview = false){
   const [Component, setComponent] = useState(null);
   const [isLoadComponent, setLoadCmponent] = useState(true);
   const [notFoundComponent, setNotFoundComponent] = useState(false);

   useEffect(() => {
      setLoadCmponent(true);
      setComponent(null);

      const renderComponent = async () => {
         try {
            let modul = null
            let path = null
            if(isPreview){
               path = `${ pathPrefix }/${ name }`;
               modul = await tryRequire(path);
            } else {
               modul = {}
            }
            if(modul){
               let component = null
               if(isPreview){
                  component = importComponent(path);
               } else {
                  const components = {
                     hero: React.lazy(async () => await import('common/designer-modules/page-template/hero')),
                     memberships: React.lazy(async () => await import('common/designer-modules/page-template/memberships')),
                     contact: React.lazy(async () => await import('common/designer-modules/page-template/contact')),
                     'about-me': React.lazy(async () => await import('common/designer-modules/page-template/about-me')),
                     'content-library': React.lazy(async () => await import('common/designer-modules/page-template/content-library')),
                     'content-showcase': React.lazy(async () => await import('common/designer-modules/page-template/content-showcase')),
                     'mailing-list': React.lazy(async () => await import('common/designer-modules/page-template/mailing-list')),
                  };
                  component = components[name]
               }
               setNotFoundComponent(false);
               setComponent(component)
            } else {
               setNotFoundComponent(true);
            }
            setLoadCmponent(false);
         } catch (error) {
            // Handle error if component doesn't exist
            setNotFoundComponent(true);
            setLoadCmponent(false);
         }

      }
      renderComponent();

      return () => {
         setComponent(null);
      }

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [name])
   return {
      Component,
      isLoadComponent,
      notFoundComponent,
   };
}
function useContentInitialFetching(contentRef, getFetchData, isDisabled){
   const [hasFetched, setHasFetched] = useState(false);


   useEffect(() => {
      let observerRefValue = null;

      const observer = new IntersectionObserver(
         ([entry]) => {
            if(entry.isIntersecting && !hasFetched) {
               getFetchData();
               setHasFetched(true); // Avoid multiple calls
               observer.unobserve(entry.target);
               observerRefValue = contentRef.current
            }
         },
         { threshold: 0.1 }
      );
      if(isDisabled){
         observer.disconnect();
         if(contentRef.current){
            observer.unobserve(contentRef.current)
         }
      }
      if(contentRef.current && !isDisabled) observer.observe(contentRef.current);

      return () => {
         if(observerRefValue) observer.unobserve(observerRefValue);
      };
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [hasFetched, isDisabled]);

}
const getScrollParent = (isPreview) => {
   let scrollParent = window;
   if(isPreview && document.querySelector('#dashboard-sitedesing-preview')){
      scrollParent = document.querySelector('#dashboard-sitedesing-preview');
   }
   return scrollParent;
}
const getContentSortingOptions = (contentType, contentCardSettings) => {
   const state = {
      story: STORIES_SORTING,
      store: STORE_SORTING,
      media: MEDIA_SORTING,
   }
   const allSorts = state[contentType] || MEDIA_SORTING;
   // if('store' !== contentType && contentCardSettings?.like) {
   //    const mostLikedSortOption = { name: 'Most liked', value: 'likes_count:desc' }
   //    allSorts.splice(4, 0, mostLikedSortOption)
   // }
   return allSorts;
}


const getMediaIndividualPagePath = (getTheHref, media) => {
   if(getTheHref && media.content_mapping_id){
      const name = media?.name || media?.title;
      const id = generateMapingIdForUrl(media.content_mapping_id);
      return getTheHref(`/${ generateUriSegment(id, name) }`)
   }
   return null
}

const generateMapingIdForUrl = (id) => {
   if(id < 10) return `00${ id }`;
   if(id < 100) return `0${ id }`;
   return id;
}

export {
   useDynamicComponentImport,
   generateApiParams,
   getContentSortingOptions,
   STORE_TYPES,
   STATUS_FILTERS,
   getScrollParent,
   useContentInitialFetching,
   VIDEO_RESOURCES_TYPES,
   RECORDED_RESOURCES_TYPES,
   PHOTOSETS_RESOURCES_TYPES,
   STORE_RESOURCES_TYPES,
   getMediaIndividualPagePath,
   generateMapingIdForUrl,
   // getSectionByPage,
}
